module.exports = __webpack_public_path__ + "img/sync-outline.770b0ea2.svg";